import React from 'react'
import styled from 'styled-components'

const CardContainer = styled.div`
    width: 80%;
    height: auto;
    position: relative;
    overflow: hidden;
    display: grid;
    /* grid-template-rows: 2fr 1fr 1fr; */
    grid-template-rows: repeat(3,auto);
    text-align: left;
    border-width: 1px;
    border-style: solid;
    border-radius: 20px;
    border-color: rgb(198, 208, 235);
    box-shadow: 0 20px 40px ${({ theme }) => theme.shadow};
    transition: all 1s cubic-bezier(0.2, 0.8, 0.2, 1);
    background: #f3f1f3;
    

    :hover{
        transform: translateY(-5px);
        box-shadow: 0 30px 60px ${({ theme }) => theme.shadow};
    }
    @media (min-width: 750px){
        width: 90%;
      }
`
const CardText = styled.p`
    color: var(--gray-800); 
    font-weight: 500;
    font-size: 1rem;
    align-self: center;
    margin: 20px 15px 0 20px;
`

const CardName = styled.h3`
    font-size: 1.4rem;
    font-weight: 700;
    margin:  40px 0 10px 20px;
    width: auto;
    background: linear-gradient(90deg, rgba(131,58,180,1) 0%, rgba(253,29,29,1) 50%, rgba(252,176,69,1) 100%);
    -webkit-background-clip: text;
    background-clip:text;
    -webkit-text-fill-color: transparent;
`
const CardJob = styled.h4`
    color: var(--gray-800); 
    font-size: 1.2rem;
    margin:  0 0 10px 20px;
    width: auto;
`

const Card = (props) => {
    return (
            <CardContainer>
                <CardText>{props.text}</CardText>
                <CardName>{props.name}</CardName>
                <CardJob>{props.position}</CardJob>
            </CardContainer>
    )
}

export default Card;
